<template>
  <div class="edit-video-box">
    <el-dialog
      class="game-dialog"
      :title="'回收游戏余额'"
      :visible.sync="dialogVisible"
      width="380px"
      :before-close="handleClose"
      :close-on-click-modal="false"

    >
      <el-form ref="form" label-width="120px">
         <el-row :gutter="24">
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
             <el-form-item label="游戏余额">
               <el-input v-model.number="balance" disabled placeholder="单位: 元"/>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="24">
           <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
             <el-form-item label="回收金额">
               <el-input v-model.number="incomeCoin" />
                <p style="margin:0;color:red">只能填写负数</p>
             </el-form-item>
           </el-col>
         </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitEdit()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      uid: "",
      dialogVisible: false,
      flag: false,
      incomeCoin: 0,
      balance: 0,
      transferaBle: 0,
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.balance = 0;
      this.transferaBle = 0;
      this.incomeCoin = 0;
      this.$refs["form"].resetFields();
    },
    // 确认修改
    // handleOK() {
    //   this.$refs["form"].validate((valid) => {
    //     if (valid) {
    //       this.flag = true;
    //       this.submitEdit();
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // 提交修改
    submitEdit() {
      let params = {
        uid: this.uid,
        credit: this.incomeCoin,
      };
      if (!params.credit) {
      this.$message({
          message: "请输入回收金额",
          type: "error",
        });
        return;
      }
      if (params.credit > 0) {
        this.$message({
          message: "回收金额只能是负数",
          type: "error",
        });
        return;
      }
      if (this.balance <= 0 && this.incomeCoin < 0) {
        this.$message({
          type: 'error',
          message: '玩家余额不足'
        })
        return false
      }
      if (this.balance > 0 && this.transferaBle < 0 && this.incomeCoin < 0) {
        this.$message({
          type: 'error',
          message: '请等待玩家下线'
        })
        return false
      }
      this.flag = true;
      API.recycleGameBal(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "回收成功",
              type: "success",
            });
            this.balance = res.data.wlBalance;
            this.transferaBle = res.data.wlTransferable;
            this.incomeCoin = 0;
          } else {
            this.$message.error("回收失败");
          }
          this.flag = false;
          // this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          // this.handleClose();
        });
    },
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      let params = {
        uid: row.uid
      }
      this.dialogVisible = true;
      this.flag = true;
      API.queryBalance(params)
      .then((res) => {
        if (res.code === 200) {
          this.balance = res.data.wlBalance;
          this.transferaBle = res.data.wlTransferable;
        } else {
          this.$message.error("回收失败");
        }
        this.flag = false;
      })
      .catch(() => {
        this.flag = false;
      });
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
}
.form_item {
  display: flex;
}
.game-dialog {
  .el-dialog__body {
    padding: 25px 25px 0 !important;
  }
}
</style>
